import { createStyles, InputBase, withStyles } from '@material-ui/core';
export const BootstrapInput = withStyles((theme) => createStyles({
    input: {
        borderRadius: '4px !important',
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: 'none',
        padding: '27px 12px 10px',
        paddingRight: '48px !important',
        cursor: 'pointer',
        '&.MuiInputBase-inputAdornedEnd': {
            backgroundColor: theme.palette.background.paper,
            borderRight: 'none',
            borderTopRightRadius: '0 !important',
            borderBottomRightRadius: '0 !important',
        },
        '&.MuiInputBase-inputAdornedEnd ~ *': {
            backgroundColor: theme.palette.background.paper,
            borderLeft: 'none',
            borderTopLeftRadius: '0 !important',
            borderBottomLeftRadius: '0 !important',
            borderTopRightRadius: '4px !important',
            borderBottomRightRadius: '4px !important',
            height: '100%',
        },
        '&:disabled, &:disabled ~ *': {
            backgroundColor: `${theme.palette.grey["300"]} !important`,
        },
        '#flight-search-filters &:disabled, #flight-search-filters &:disabled ~ *': {
            backgroundColor: `${theme.palette.common.white} !important`,
            color: theme.palette.common.black,
        }
    },
    root: {
        borderRadius: '4px !important',
        border: '1px solid #ced4da',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus, &:hover': {
            backgroundColor: theme.palette.background.paper,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: theme.palette.primary.main,
            transition: 0,
        },
        '&.Mui-error': {
            borderColor: theme.palette.error.main,
        },
    }
}))(InputBase);
